// extracted by mini-css-extract-plugin
export default {"okModal":"OkModal_okModal__Fy6RY","okText":"OkModal_okText__qzjdG","okBtn":"OkModal_okBtn__64hF4","okParagraph":"OkModal_okParagraph__taVkF"};